import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import Residential from "@/pages/Residential";
import Commercial from "@/pages/Commercial";
import HousingSocieties from "@/pages/HousingSocieties";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Chatbot from "@/components/Chatbot";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center text-stone-500">
        Checking session…
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function ChatbotMount() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <Chatbot />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/residential" element={<Residential />} />
              <Route path="/commercial" element={<Commercial />} />
              <Route path="/housing-societies" element={<HousingSocieties />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ChatbotMount />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}
